<template>
  <div class="h-full w-full mt-5 text-left flex flex-col">
    <label
      class="mb-2 text-xs md:text-xs text-gray-600 text-opacity-80 font-bold"
      >{{ label }}</label
    >
    <a-range-picker
      :allow-clear="allowClear"
      :value="momentValue"
      @change="onChange"
      :placeholder="['Fecha de inicio', 'Fecha de fin']"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    label: { type: String, default: "Periodo" },
    allowClear: { type: Boolean, default: true },
    value: { type: Array, default: null },
  },
  computed: {
    momentValue() {
      if (this.value && this.value.length === 2 && this.value[0] && this.value[1]) {
        return [moment(this.value[0], "YYYY-MM-DD"), moment(this.value[1], "YYYY-MM-DD")];
      }
      return null;
    }
  },
  methods: {
    onChange(dates, dateString) {
      this.$emit("notify-dates", dateString);
    },
  },
};
</script>
